export default "__VITE_ASSET__ea619e81__"